import { OrganizationKeyName } from "../../../model/Organization";

export const GET_PRODUCT = "SHOP:GET_PRODUCT";

export const getProductAction = (
  organization: OrganizationKeyName,
  id: string
) => ({
  type: GET_PRODUCT as typeof GET_PRODUCT,
  organization,
  id,
});

export type GetProductAction = ReturnType<typeof getProductAction>;
